import React, {useState, useContext} from 'react'
import {TitlesContext, ContentContext} from '../Store'
import { config } from '../server'
import { useAuth0 } from '@auth0/auth0-react';
const address = config.url.API_URL

const AddCard = (props) => { 
const [titles, setTitles] = useContext(TitlesContext);
const [content, setContent] = useContext(ContentContext)
const [showForm, setShowForm] = useState(true)
const [formCount, setFormCount] = useState(0)
const { user } = useAuth0();


  function handleTitleChange(i, event) {
    const values = [...titles];
    values[i] = event.target.value;
    setTitles(values);
  }
  function handleContentChange(i, event) {
    const values = [...content];
    values[i] = event.target.value;
    setContent(values);
  }

  function handleAdd() {
    const values = [...titles];
    values.push('');
    setTitles(values);
    const values2 = [...content]
    values2.push('')
    setContent(values2)
  }

  function handleRemove(i) {
    const values = [...titles];
    values.splice(i, 1);
    setTitles(values);
    const values2 = [...content];
    values2.splice(i, 1)
    setContent(values2)
  }

  function handleSubmit(event){
    event.preventDefault()
    for(let title of titles) {
      if(title.length === 0) {
        alert("Please fill out the form with at least one letter")
        return;
      }
    }
    for(let con of content) {
      if(con.length === 0) {
        alert("Please fill out the form with at least one letter")
        return;
      }
    }

    setFormCount(formCount+1)
    const requestOptions = {
      method: 'POST',
      headers: { 
        'content-type': 'application/json' },
      body: JSON.stringify({ name: user.nickname,studyTitle: props.studyTitle, topicName: props.topic.topicName, cardTitles: titles, cardContent: content, formCount: formCount})
  };
    fetch(address + '/api/createSet', requestOptions).then(res => res.json()).then(data => {
     // console.log(data)
    });  
    setShowForm(false)
  }


  return (
    <div>
    <button onClick={() => setShowForm(!showForm)} className="button is-medium">{props.topic.topicName}</button>
    {showForm && (<div className="level-item" style={{paddingTop: "1%"}}>
      <form onSubmit={handleSubmit}>
      {titles.map((el, idx) => {
        return (
          <div key={idx}>
            <div style={{paddingTop: "10%"}} className="is-half level">
            <input
              type="text"
              placeholder="Enter title of card"
              className="input"
              onChange={e => handleTitleChange(idx, e)}
            />
            <br/>
            </div>
            <div key={idx+1} className="level">
              <textarea 
                className="textarea" 
                placeholder="Enter description for card" 
                rows="2" type="text"  
                onChange={e => handleContentChange(idx, e)}>
              </textarea>
              <div key={idx+1}>
                <button type="button" className="button is-danger level-item"  onClick={() => handleRemove(idx)}>Remove</button>
              </div>
            </div>
          </div>
        );
      })}
      <div className="level" style={{paddingTop: "10%"}}>
        <div className="level-item">
          <button type="button" className="button is-link" onClick={() => handleAdd()}>Add</button>
        </div>
        <div className="level-item">
          <input type="submit" value="Submit" className="is-primary button level-item"/>
        </div>
      </div>
      </form>
    </div>)}
  </div>
  );
}


export default AddCard